// extracted by mini-css-extract-plugin
module.exports = {"aff_about_content":"ab_aff_about_content__NUXx9","aff_about_container":"ab_aff_about_container__bCIm5","aff_about_t":"ab_aff_about_t__fVQiQ"};